import React from 'react';
import {
  Box,
  TextField,
  Button,
  Stack,
  Typography,
  CircularProgress,
} from '@mui/material';
import { useLabourItemUIStore } from '../stores/labourItemUIStore';
import { useCreateLabourDefinition } from '../hooks/useLabourDefinitionMutations';

const ItemCreatePanel: React.FC = () => {
  const addItemFormName = useLabourItemUIStore(state => state.addItemFormName);
  const setAddItemFormName = useLabourItemUIStore(
    state => state.setAddItemFormName
  );
  const closePanel = useLabourItemUIStore(state => state.closePanel);

  const createMutation = useCreateLabourDefinition();

  const handleConfirmAdd = () => {
    createMutation.mutate(addItemFormName, {
      onSuccess: () => closePanel(),
    });
  };

  const handleCancel = () => {
    closePanel();
  };

  return (
    <Box sx={{ p: 3 }} data-testid="item-create-content">
      <Typography variant="h6" gutterBottom>
        Add Labour Item
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Enter the name of the new labour item
      </Typography>

      <Stack spacing={3}>
        <TextField
          autoFocus
          type="text"
          fullWidth
          label="Item Name"
          value={addItemFormName}
          onChange={e => setAddItemFormName(e.target.value)}
          disabled={createMutation.isPending}
          data-testid="add-item-input"
        />

        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            onClick={handleCancel}
            disabled={createMutation.isPending}
            sx={{ flex: 1 }}
            data-testid="add-item-cancel"
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmAdd}
            variant="contained"
            disabled={!addItemFormName.trim() || createMutation.isPending}
            sx={{ flex: 1 }}
            data-testid="add-item-confirm"
          >
            {createMutation.isPending ? (
              <CircularProgress size={16} sx={{ mr: 1 }} />
            ) : null}
            Add
          </Button>
        </Box>
      </Stack>
    </Box>
  );
};

export default ItemCreatePanel;
